import React, { CSSProperties } from 'react';
import styles from "./column-container.module.scss";
import borders from "../../styles/borders.module.scss";

enum ColumnSizes {
    three_quarters,
    two_thirds,
    half,
    one_third,
    one_quarter,
    full,
    one_fifth,
    two_fifths,
    three_fifths,
    four_fifths,
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven,
    twelve,
    narrow
}

enum OffsetSizes {
    three_quarters,
    two_thirds,
    half,
    one_third,
    one_quarter,
    one_fifth,
    two_fifths,
    three_fifths,
    four_fifths,
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven
}

enum BorderTypes {
    left,
    right,
    bottom,
    top,
    all
}

export interface IColumnProps {
    
}

const Column = ({
    visible,
    size,
    offset,
    borderType,
    centerHorizontal,
    centerVertical,
    testId,
    children,
}: React.PropsWithChildren<{
    visible?: boolean | null,
    size?: ColumnSizes | null,
    offset?: OffsetSizes | null,
    borderType?: BorderTypes[] | null,
    centerHorizontal?: boolean,
    centerVertical?: boolean,
    testId?: string
}>): JSX.Element => {
    let style: CSSProperties = {};
    if (visible === false) {
        style.display = "none";
    }
    let className = styles.column + (centerHorizontal ? ' ' + styles.is_centered : '') + (centerVertical ? ' ' + styles.is_vcentered : '');
    if (size !== null && size!==undefined) {
        switch (size) {
            case ColumnSizes.three_quarters:
                className += ' ' + styles.is_three_quarters;
                break;
            case ColumnSizes.two_thirds:
                className += ' ' + styles.is_two_thirds;
                break;
            case ColumnSizes.half:
                className += ' ' + styles.is_half;
                break;
            case ColumnSizes.one_third:
                className += ' ' + styles.is_one_third;
                break;
            case ColumnSizes.one_quarter:
                className += ' ' + styles.is_one_quarter;
                break;
            case ColumnSizes.full:
                className += ' ' + styles.is_full;
                break;
            case ColumnSizes.one_fifth:
                className += ' ' + styles.is_one_fifth;
                break;
            case ColumnSizes.two_fifths:
                className += ' ' + styles.is_two_fifths;
                break;
            case ColumnSizes.three_fifths:
                className += ' ' + styles.is_three_fifths;
                break;
            case ColumnSizes.four_fifths:
                className += ' ' + styles.is_four_fifths;
                break;
            case ColumnSizes.one:
                className += ' ' + styles.is_1;
                break;
            case ColumnSizes.two:
                className += ' ' + styles.is_2;
                break;
            case ColumnSizes.three:
                className += ' ' + styles.is_3;
                break;
            case ColumnSizes.four:
                className += ' ' + styles.is_4;
                break;
            case ColumnSizes.five:
                className += ' ' + styles.is_5;
                break;
            case ColumnSizes.six:
                className += ' ' + styles.is_6;
                break;
            case ColumnSizes.seven:
                className += ' ' + styles.is_7;
                break;
            case ColumnSizes.eight:
                className += ' ' + styles.is_8;
                break;
            case ColumnSizes.nine:
                className += ' ' + styles.is_9;
                break;
            case ColumnSizes.ten:
                className += ' ' + styles.is_10;
                break;
            case ColumnSizes.eleven:
                className += ' ' + styles.is_11;
                break;
            case ColumnSizes.twelve:
                className += ' ' + styles.is_12;
                break;
            case ColumnSizes.narrow:
                className += ' ' + styles.is_narrow;
                break;
        }
    }
    if (offset !== null && offset!==undefined) {
        switch (offset) {
            case OffsetSizes.three_quarters:
                className += ' ' + styles.is_offset_three_quarters;
                break;
            case OffsetSizes.two_thirds:
                className += ' ' + styles.is_offset_two_thirds;
                break;
            case OffsetSizes.half:
                className += ' ' + styles.is_offset_half;
                break;
            case OffsetSizes.one_third:
                className += ' ' + styles.is_offset_one_third;
                break;
            case OffsetSizes.one_quarter:
                className += ' ' + styles.is_offset_one_quarter;
                break;
            case OffsetSizes.one_fifth:
                className += ' ' + styles.is_offset_one_fifth;
                break;
            case OffsetSizes.two_fifths:
                className += ' ' + styles.is_offset_two_fifths;
                break;
            case OffsetSizes.three_fifths:
                className += ' ' + styles.is_offset_three_fifths;
                break;
            case OffsetSizes.four_fifths:
                className += ' ' + styles.is_offset_four_fifths;
                break;
            case OffsetSizes.one:
                className += ' ' + styles.is_offset_1;
                break;
            case OffsetSizes.two:
                className += ' ' + styles.is_offset_2;
                break;
            case OffsetSizes.three:
                className += ' ' + styles.is_offset_3;
                break;
            case OffsetSizes.four:
                className += ' ' + styles.is_offset_4;
                break;
            case OffsetSizes.five:
                className += ' ' + styles.is_offset_5;
                break;
            case OffsetSizes.six:
                className += ' ' + styles.is_offset_6;
                break;
            case OffsetSizes.seven:
                className += ' ' + styles.is_offset_7;
                break;
            case OffsetSizes.eight:
                className += ' ' + styles.is_offset_8;
                break;
            case OffsetSizes.nine:
                className += ' ' + styles.is_offset_9;
                break;
            case OffsetSizes.ten:
                className += ' ' + styles.is_offset_10;
                break;
            case OffsetSizes.eleven:
                className += ' ' + styles.is_offset_11;
                break;
        }
    }
    if (borderType !== null && borderType !== undefined) {
        borderType.forEach((value) => {
            switch (value) {
                case BorderTypes.left:
                    className += ' ' + borders.is_bordered_left;
                    break;
                case BorderTypes.right:
                    className += ' ' + borders.is_bordered_right;
                    break;
                case BorderTypes.bottom:
                    className += ' ' + borders.is_bordered_bottom;
                    break;
                case BorderTypes.top:
                    className += ' ' + borders.is_bordered_top;
                    break;
                case BorderTypes.all:
                    className += ' ' + borders.is_bordered;
                    break;
            }
        });
    }
    return (
        <div data-testid={testId} className={className} style={style}>
            {children}
        </div>
    );
};

Column.displayName = 'Column';
export { Column, ColumnSizes, OffsetSizes, BorderTypes };
